import { ReactElement, ReactNode, createContext } from 'react';
import ToastNotification from '../common/toast-notification/toast-notification';
import { ToastContextProps } from '../types/toast-notification';
import useToast from './hooks/use-toast';

export const ToastContext = createContext<ToastContextProps | undefined>(undefined);
export const ToastProvider = ({ children }: { children: ReactNode }): ReactElement => {
    const toast = useToast();

    return (
        <ToastContext.Provider value={{ showToast: toast.show }}>
            {children}

            <ToastNotification {...toast} />
        </ToastContext.Provider>
    );
};
